import axios from 'axios';

export const AUCTION_API = `${process.env.REACT_APP_BACKEND_URL}/api/auction`;

export const ax = axios.create({ baseURL: AUCTION_API, withCredentials: true });

export function apiError(err, fallback = 'Something went wrong. Please try again.') {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (d && typeof d.msg === 'string') return d.msg;
  return String(d);
}

// Public
export const getCurrentAuction = () => ax.get('/current').then((r) => r.data);
export const listVehicles = (params) => ax.get('/vehicles', { params }).then((r) => r.data);
export const getVehicle = (id) => ax.get(`/vehicles/${id}`).then((r) => r.data);

// Buyer
export const buyerRegister = (data) => ax.post('/buyers/register', data).then((r) => r.data);
export const buyerLogin = (data) => ax.post('/buyers/login', data).then((r) => r.data);
export const buyerLogout = () => ax.post('/buyers/logout').then((r) => r.data);
export const buyerMe = () => ax.get('/buyers/me').then((r) => r.data);
export const myOffers = () => ax.get('/buyers/offers').then((r) => r.data);
export const submitOffer = (vehicleId, data) => ax.post(`/vehicles/${vehicleId}/offers`, data).then((r) => r.data);

// Auction admin
export const adminLogin = (data) => ax.post('/auth/login', data).then((r) => r.data);
export const adminLogout = () => ax.post('/auth/logout').then((r) => r.data);
export const adminMe = () => ax.get('/auth/me').then((r) => r.data);
export const adminListAuctions = () => ax.get('/admin/auctions').then((r) => r.data);
export const adminCreateAuction = (data) => ax.post('/admin/auctions', data).then((r) => r.data);
export const adminUpdateAuction = (id, data) => ax.put(`/admin/auctions/${id}`, data).then((r) => r.data);
export const adminDeleteAuction = (id) => ax.delete(`/admin/auctions/${id}`).then((r) => r.data);
export const adminListVehicles = (params) => ax.get('/admin/vehicles', { params }).then((r) => r.data);
export const adminCreateVehicle = (data) => ax.post('/admin/vehicles', data).then((r) => r.data);
export const adminUpdateVehicle = (id, data) => ax.put(`/admin/vehicles/${id}`, data).then((r) => r.data);
export const adminDeleteVehicle = (id) => ax.delete(`/admin/vehicles/${id}`).then((r) => r.data);
export const adminUploadImages = (id, formData) => ax.post(`/admin/vehicles/${id}/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
export const adminRemoveImage = (id, url) => ax.patch(`/admin/vehicles/${id}/images/remove`, { url }).then((r) => r.data);
export const adminImportExcel = (formData, auctionId) => ax.post('/admin/vehicles/import', formData, { params: auctionId ? { auction_id: auctionId } : {}, headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
export const templateUrl = `${AUCTION_API}/admin/vehicles/template`;
export const adminListOffers = (params) => ax.get('/admin/offers', { params }).then((r) => r.data);
export const adminUpdateOffer = (id, status) => ax.patch(`/admin/offers/${id}/status`, { status }).then((r) => r.data);

export const imgSrc = (url) => (url?.startsWith('http') ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);

export const SOURCE_LABELS = { 'ex-rental': 'Ex-Rental', 'lease-return': 'Lease Return', 'fleet-disposal': 'Fleet Disposal', 'trade-in': 'Trade-In', 'repossession': 'Repossession', 'damaged': 'Damaged Vehicle', 'other': 'Other' };
export const STATUS_LABELS = { 'in-yard': 'In Yard', 'under-inspection': 'Under Inspection', 'documentation-pending': 'Documentation Pending', 'ready-for-auction': 'Ready for Auction', 'sold': 'Sold', 'released': 'Released', 'unavailable': 'Unavailable' };
export const VAT_LABELS = { 'vat-inclusive': 'VAT-inclusive (5%)', 'margin-scheme': 'VAT on margin scheme', 'zero-rated-export': 'Zero-rated / Export', 'vat-exempt': 'VAT-exempt' };
